/* eslint-disable @typescript-eslint/no-var-requires, no-extend-native, @typescript-eslint/no-explicit-any */
// @ts-nocheck

// Eventually, we should include all our vendor code here.
// For now, it essentially functions as a polyfill file.

// loading-attribute-polyfill is located in bootstrapper.ts instead
// since it needs to run after rehydration.

if (globalThis.window !== undefined) {
  require('whatwg-fetch');
  require('element-closest');
  require('intersection-observer');
}

export const isIE11 =
  !!globalThis.MSInputMethodContext && !!globalThis.document.documentMode;

export const loadPolyfills = async () => {
  if (isIE11) {
    const { load } = await import(
      /* webpackChunkName: "polyfills/ie11-shim" */
      './ie11'
    );
    await load();
  }

  return;
};

Element.prototype.getAttributeNames ??= function () {
  const attributes = this.attributes;
  const length = attributes.length;
  const result = new Array(length);
  for (let i = 0; i < length; i++) {
    result[i] = attributes[i].name;
  }
  return result;
};
